import { AppAction, AsyncActionType, BaseAsyncReducerState } from "./types";


export default function defaultAsyncReducer(state: BaseAsyncReducerState, action: AppAction, actionType: AsyncActionType):BaseAsyncReducerState | Record<string, unknown>{
    const { payload } = action;

    switch (action.type) {
        case actionType.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case actionType.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,

            }

        case actionType.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}